export function noop(): void {
    /* no operation callback */
}
